<template>
  <div class="mapContent">
    <el-image-viewer style="z-index: 9999;" v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
    <el-button v-if="isChange" class="manualInput" type="primary" @click="showDialog = true">
      <svg class="global-icon" aria-hidden="true">
        <use xlink:href="#icon-icon_shoudongshuru"></use>
      </svg>
      手动输入
    </el-button>
    <div id="map">
      <div class="infoWindow" ref="input" v-if="fenceCodeShow && locationList.fileList.length">
        <div class="line">
          <div class="label"><span style="color:red">*</span>数量：</div>
          <el-input v-model="fenceCode" @input="fenceCodeChange"></el-input>
          <el-button type="text" @click="save" class="save">保存</el-button>
          <el-button type="text" @click="deleteMarker">删除</el-button>
        </div>
        <div class="line">
          <span class="label">胸径(cm)：</span>
          <el-input v-model="treeWidth" @input="fenceCodeChange2"></el-input>
        </div>
        <div class="line">
          <span class="label">生长态势：</span>
          <el-radio-group v-model="growthTrend" class="radioGroup">
            <el-radio-button label="2">不佳</el-radio-button>
            <el-radio-button label="1">一般</el-radio-button>
            <el-radio-button label="0">良好</el-radio-button>
          </el-radio-group>
        </div>

        <div class="block">
          <span class="label">生长图片(最多三张)：</span>
          <div class="imgList">
            <div class="imgBlock" v-for="(item, index) in fileList" :key="index">
              <el-image :src="item.filePrefix + item.fileUrl" :preview-src-list="fileList | previewList" fit="fill">
              </el-image>
              <span></span>
              <i class="el-icon-close" @click="imgRemove(index)"></i>
            </div>
            <UploadFile style="width: 85px;height: 85px;" :accept="'jpeg,jpg,png'" @onSuccess="onSuccess"
              :slotShow='true' v-if="fileList?.length < 3">
              <i class="el-icon-plus"></i>
              <p>上传图片</p>
            </UploadFile>
          </div>
        </div>
      </div>
    </div>
    <div class="layer" v-if="mapModel">
      <div :class="{ active: currentIndex === 0 }" @click="changeLayer(0)">2D</div>
      <div :class="{ active: currentIndex === 1 }" @click="changeLayer(1)">卫星</div>
    </div>
    <el-dialog title="手动输入经纬度" :visible.sync="showDialog" width="320px" :modal-append-to-body="false"
      :before-close="handleClose">
      <el-form class="global-form111" inline :model="locInfo" ref="locInfo" :rules="locRules" label-width="60px">
        <el-form-item label="经度" prop="lng">
          <el-input v-model="locInfo.lng" placeholder="请输入经度" clearable></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="lat">
          <el-input v-model="locInfo.lat" placeholder="请输入纬度" clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="text-center">
        <el-button type="primary" @click="onAdd('locInfo')">添加</el-button>
        <el-button @click="onCancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { drawPolygon } from '@/utils/formatData'
import UploadFile from '@/components/uploadFile/Index.vue'

export default {
  name: 'MapLocation',
  components: { UploadFile, 'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer') },
  props: {
    ancientTrees: {
      type: Boolean,
      default: false
    },
    numberInput: {
      type: Boolean,
      default: false
    },
    isChange: {
      type: Boolean,
      default: true
    },
    projectId: {
      type: String
    },
    projectAreaId: String,
    locationList: Array,
    icon: String,
    name: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: ''
    },
    mapModel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      map: null,
      marker: null,
      infoWindow: null,
      fenceCode: null,
      treeWidth: null,
      growthTrend: '',
      fileList: [],
      imgViewerVisible: false,
      imgList: [],
      fenceCodeShow: false,
      ploygons: [],
      showDialog: false,
      locInfo: {
        lng: '',
        lat: ''
      },
      locRules: {
        lng: [{ required: true, message: '请输入经度' }],
        lat: [{ required: true, message: '请输入纬度' }]
      },

      currentIndex: 0
    }
  },
  watch: {
    locationList() {
      this.map && this.markerListAdd()
    },
    projectId() {
      this.getProjectLocation()
    },
    projectAreaId(val) {
      if (val) {
        this.getAreaDetail()
      }
    }
  },
  filters: {
    imgListFormat(list) {
      const imgTypeList = ['jpeg', 'jpg', 'png']
      const imgList = []
      list.forEach((item) => {
        const str = item.fileName.split('.')
        if (imgTypeList.find((items) => items === str[str.length - 1].toLowerCase())) {
          imgList.push(item.filePrefix + item.fileUrl)
        }
      })
      return imgList || []
    },
    previewList: function (value) {
      return value.map((item) => {
        return item.filePrefix + item.fileUrl
      })
    }
  },
  created() {
    // this.loadMap()
  },
  mounted() {
    this.$nextTick(() => {
      this.loadMap()
    })
  },
  destroyed() {
    if (this.map) {
      this.map.off('click', null)
      // 暂时兼容this.map.getAllOverlays('marker')报错问题
      if (this.map.getAllOverlays().length > 0) {
        this.map.getAllOverlays().forEach(item => {
          if (item.className && item.className.toLocaleLowerCase().includes('marker')) {
            item.off('click', () => {
              // 清除marker事件
            })
          }
        })
      }
      this.map.destroy()
    }
  },
  methods: {
    // 获取项目电子围栏
    getProjectLocation() {
      if (this.ploygons) {
        this.ploygons.forEach(item => {
          item.off('click', () => {
            // 清除ploygons事件
          })
        })
      }
      this.$axios.get(this.$apis.project.selectYhProjectMapByProjectId, {
        projectId: this.projectId
      }).then((res) => {
        this.ploygons = drawPolygon(this.map, res.locationList, null, (e) => {
          this.isChange && this.markerClick([e.lnglat.getLng(), e.lnglat.getLat()])
        })
      })
    },

    // 区域详情
    getAreaDetail() {
      if (this.ploygons) {
        this.ploygons.forEach(item => {
          item.off('click', () => {
            // 清除ploygons事件
          })
        })
      }
      this.$axios.get(this.$apis.project.selectYhProjectAreaByProjectAreaId, {
        projectAreaId: this.projectAreaId
      }).then((res) => {
        if (this.map) {
          this.map.remove(this.ploygons)
          this.ploygons = drawPolygon(this.map, res.locationList, null, (e) => {
            this.isChange && this.markerClick([e.lnglat.getLng(), e.lnglat.getLat()])
          })
        }
      })
    },

    loadMap() {
      this.map = new AMap.Map('map', {
        zoom: 11,
        doubleClickZoom: false
      })
      if (this.projectAreaId) {
        this.getAreaDetail() // 获取区域电子围栏
      } else if (this.projectId) {
        this.getProjectLocation() // 获取项目电子围栏
      }
      this.markerListAdd() // 通过 this.locationList 回显选中的点
      // this.isChange 为假就是详情，不绑定点击事件
      this.isChange && this.map.on('click', (e) => {
        this.markerClick([e.lnglat.getLng(), e.lnglat.getLat()])
      })
    },
    handleClose(done) {
      this.resetForm('locInfo')
      done()
    },

    onCancel() {
      this.resetForm('locInfo')
      this.showDialog = false
    },

    // 手动添加点
    onAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.markerClick([Number(this.locInfo.lng), Number(this.locInfo.lat)])
          this.onCancel()
        } else {
          return false
        }
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
    },

    // 添加marker
    markerClick(position) {
      // 古树的添加和编辑走这里的代码
      if (!this.numberInput && this.marker) {
        this.marker.setMap(null)
        this.marker = null
      }
      // 往地图上添加一个 marker 点
      this.markerAdd([Number(position[0]), Number(position[1])], { fenceCode: 1 })
      // 古树的添加和编辑不走这里的代码，没有数量,默认为1
      if (this.numberInput) {
        // 添加数量文本窗
        this.addSetLabel({
          fenceCode: 1,
          treeWidth: '',
          growthTrend: '0',
          fileList: []
        })

        // 打开弹窗
        this.openInfoWindow(this.marker)
        // 绑定 marker 点击事件，控制弹窗显示隐藏
        this.marker.on('click', (MapsEvent) => {
          if (this.infoWindow) {
            this.infoWindow.close() // 关闭信息窗
            this.infoWindow = null
          } else {
            this.openInfoWindow(MapsEvent.target)
          }
        })
      }
      this.markerChange()
    },

    // 往地图上添加一个点且添加参数
    markerAdd(position, item) {
      this.marker = new AMap.Marker({
        icon: new AMap.Icon({
          // 图标的取图地址
          image: this.icon
        }),
        offset: new AMap.Pixel(-20, -40),
        extData: {
          data: {
            fenceCode: item.fenceCode,
            longitude: Number(position[0]),
            latitude: Number(position[1]),
            treeWidth: item.treeWidth || '',
            growthTrend: item.growthTrend || '0',
            fileList: item.fileList || []
          }
        },
        position: [Number(position[0]), Number(position[1])]
      })
      this.map.add(this.marker) // 将一个图层添加到地图上
    },

    // 回显
    markerListAdd() {
      this.locationList && this.locationList.forEach((item) => {
        // 根据 经纬度 和 fenceCode 添加点
        this.markerAdd([Number(item.longitude), Number(item.latitude)], item)
        if (this.numberInput || !this.isChange) {
          this.addSetLabel(item)
        }
        // 详情点击marker只放大图片
        !this.isChange && this.marker.on('click', (MapsEvent) => {
          this.showImgViewer(MapsEvent.target._originOpts.extData.data.fileList)
        })
        // 新增或编辑点击marker打开infoWindow及放大图片
        this.isChange && this.marker.on('click', (MapsEvent) => {
          if (this.infoWindow) {
            this.infoWindow.close() // 关闭信息窗
            this.infoWindow = null
          } else {
            this.numberInput && this.openInfoWindow(MapsEvent.target)
          }
        })
      })
    },

    // 打开弹窗
    openInfoWindow(target) {
      this.fenceCode = null
      this.treeWidth = null
      this.growthTrend = null
      this.fileList = null

      this.marker = target
      this.fenceCodeShow = true
      this.$nextTick(() => {
        this.infoWindow = new AMap.InfoWindow({
          isCustom: true, // 使用自定义窗体
          content: (this.$refs.input),
          offset: new AMap.Pixel(0, -45)
        })
        this.fenceCode = this.marker.getExtData().data.fenceCode
        this.treeWidth = this.marker.getExtData().data.treeWidth
        this.growthTrend = this.marker.getExtData().data.growthTrend
        this.fileList = this.marker.getExtData().data.fileList
        this.infoWindow.open(this.map, target.getPosition())
      })
    },

    showImgViewer(row) {
      if (!row.length) {
        return
      }
      this.imgList = []
      row.forEach((item) => {
        this.imgList.push(`${item.filePrefix}${item.fileUrl}`)
      })
      this.imgViewerVisible = true
      const m = (e) => { e.preventDefault() }
      document.body.style.overflow = 'hidden'
      document.addEventListener('touchmove', m, false) // 禁止页面滑动
    },

    closeImgViewer() {
      this.imgViewerVisible = false
      const m = (e) => { e.preventDefault() }
      document.body.style.overflow = 'auto'
      document.removeEventListener('touchmove', m, true)
    },

    // 文件上传成功返回
    onSuccess(file) {
      this.fileList.push(file)
    },

    imgRemove(index) {
      this.fileList.splice(index, 1)
    },

    // 保存
    save() {
      if (this.fenceCode) {
        this.marker.getExtData().data.fenceCode = this.fenceCode
        this.marker.getExtData().data.treeWidth = this.treeWidth
        this.marker.getExtData().data.growthTrend = this.growthTrend
        this.marker.getExtData().data.fileList = this.fileList
        this.addSetLabel({
          fenceCode: this.fenceCode,
          treeWidth: this.treeWidth,
          growthTrend: this.growthTrend,
          fileList: this.fileList
        })

        this.infoWindow.close() // 关闭信息窗
        this.infoWindow = null
        this.markerChange()
      } else {
        this.$message.warning('请输入1~9999的整数')
      }
    },

    // 删除点
    deleteMarker() {
      this.marker.remove()
      this.infoWindow.close() // 关闭信息窗
      this.infoWindow = null
      this.markerChange()
    },

    // 添加数量文本窗
    addSetLabel(item) {
      if (!item.fileList) return
      let imgBlock = '<div class="img"><p>现场图片：'
      if (item.fileList.length > 0) {
        imgBlock += '</p><div class="list">'
          ; (item.fileList || []).forEach(img => {
            imgBlock += `<img src="${img.filePrefix + img.fileUrl}" id="btn2" alt="" srcset="">`
          })
        imgBlock += '</div>'
      } else {
        imgBlock += '<span>--</span></p>'
      }
      imgBlock += '</div>'
      let html = ''
      if (!this.ancientTrees) {
        html = `<div class="infoWindow2" v-html>
            <div class="line">
              <p class="item">数量：<span>${item.fenceCode}</span></p></n>
              <p class="item">胸径：<span>${item.treeWidth || '--'}</span></p>
            </div>
            <p>生产态势：<span>${item.growthTrend === '0' ? '良好' : item.growthTrend === '1' ? '一般' : '不佳'}</span></p>
            ${imgBlock}
          </div>`
      } else {
        html = `<div>
        </div>`
      }
      this.marker.setLabel({
        content: html, // 设置文本标注内容
        offset: new AMap.Pixel(0, -10),
        direction: 'top' // 设置文本标注方位
      })
    },

    // 返回数据
    markerChange() {
      const locationList = []
      // 兼容 this.map.getAllOverlays('marker') 报错
      this.map.getAllOverlays().forEach(item => {
        if (item.className && item.className.toLocaleLowerCase().includes('marker')) {
          locationList.push(item.getExtData().data)
        }
      })
      // this.map.getAllOverlays('marker').forEach((item) => {
      //   // locationList.push(item.getExtData().data)
      // })
      this.$emit('locationChange', locationList)
    },

    fenceCodeChange(value) {
      if (value && Number(value) > 9999) {
        this.fenceCode = Number(value.substr(0, 4))
      } else if (value) {
        this.fenceCode = Number(value.replace(/[^0-9]/g, ''))
      }
    },

    fenceCodeChange2(value) {
      if (value && Number(value) > 9999) {
        this.treeWidth = Number(value.substring(0, 4))
      } else if (value) {
        this.treeWidth = Number(value.replace(/[^0-9]/g, ''))
      }
      if (value.indexOf('.') !== -1) { // 如果输入框中包含多个小数点
        this.treeWidth = value.substring(0, value.indexOf('.') + 3)// 取小数点前两位和小数点
      }
    },

    changeLayer(value) {
      this.currentIndex = value
      this.map.setLayers([])
      if (value === 0) {
        // 添加标准地图图层
        this.map.setMapStyle('amap://styles/normal')
        this.map.add(new AMap.TileLayer())
      } else {
        // 添加卫星地图图层
        this.map.add(new AMap.TileLayer.Satellite())
      }
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/assets/scss/color";

.mapContent {
  position: relative;
  width: 100%;
  max-width: 800px;
  height: 427px;

  .manualInput {
    position: absolute;
    left: 16px;
    top: 16px;
    width: auto;
    z-index: 22;

    .global-icon {
      margin-right: 2px;
    }
  }

  ::v-deep {

    .el-dialog__wrapper,
    .v-modal {
      position: absolute;

      .el-dialog {
        margin-top: 80px !important;
      }
    }

    .el-form-item {
      .el-input {
        width: 200px;
      }
    }
  }

  #map {
    width: 100%;
    max-width: 100%;
    height: 427px;
  }
}

.global-form111 {
  .el-input {
    width: 200px !important;
  }
}

.radioGroup {
  margin: 0;
}

.infoWindow {
  // display: flex;
  // justify-content: center;
  // align-items: center;
  padding: 15px;
  width: 320px;
  min-height: 350px;
  height: auto;
  // height: 120px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(115, 115, 115, 0.2);

  .line {
    display: flex;
    height: 40px;
    margin: 5px 0;

    .label {
      display: inline-block;
      width: auto;
      text-align: right;
      flex-shrink: 0;
    }
  }

  span {
    font-size: 14px;
  }

  .el-input {
    width: 86px;
    margin: 0 6px;
  }

  .save {
    margin: 0 10px 0 20px;
  }

  .el-button {
    font-size: 14px;
  }
}

::v-deep .amap-marker-label {
  border: none;
  padding: 0;

  .h80 {
    height: 80px !important;
  }

  .infoWindow2 {
    width: 226px;
    height: 160px;
    color: #333333FF;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(115, 115, 115, 0.2);
    font-size: 14px;
    padding: 10px 10px;

    .line {
      display: flex;
      line-height: 25px;

      .item {
        flex: 1;
      }
    }

    .img {
      .list {
        display: flex;

        img {
          width: 50px;
          height: 50px;
          margin: 10px 10px 10px 0;
        }
      }
    }

    p {
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span {
      margin: 0 3px 0 5px;
    }
  }
}

.imgList {
  width: 100%;
  min-height: 104px;
  display: flex;
  margin-top: 15px;
  flex-wrap: wrap;

  .imgListTitle {
    margin-right: 10px;
  }

  .imgBlock {
    position: relative;
    height: 85px;
    width: 85px;
    margin: 0 10px 10px 0 !important;

    .el-image,
    img,
    video {
      width: 100%;
      height: 100%;
    }

    span {
      position: absolute;
      top: 0;
      right: 0;
      width: 0px;
      height: 0px;
      border-top: 34px solid $color-default;
      border-left: 34px solid transparent;
    }

    i {
      transition: all 0.3s;
      position: absolute;
      top: 3px;
      right: 3px;
      font-size: 15px;
      color: #ffffff;
      cursor: pointer;
    }

    i:hover {
      color: #ffffff98;
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 85px;
    height: 85px;
    line-height: 26px;
    padding: 25px 10px;

    i {
      font-size: 22px;
      color: #999;
      margin-bottom: 7px;
    }
  }

  ::v-deep .el-upload {
    display: flex;
    flex-direction: column;
    justify-content: center !important;
    align-items: center !important;
  }
}

.layer {
  display: flex;
  position: absolute;
  right: 20px;
  bottom: 20px;
  z-index: 99999;
  background: #FFFFFF;
  font-size: 12px;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 32px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    cursor: pointer;

    &.active {
      background: #5750EB;
      color: #ffffff;
    }
  }
}
</style>
